module.exports = __webpack_public_path__ + "static/media/reportatge-magazinepublicacions-1.5ebb2d94.jpg";